import { render, staticRenderFns } from "./BannerPromo.vue?vue&type=template&id=28c1e516&scoped=true&"
import script from "./BannerPromo.vue?vue&type=script&lang=js&"
export * from "./BannerPromo.vue?vue&type=script&lang=js&"
import style0 from "./BannerPromo.vue?vue&type=style&index=0&id=28c1e516&scoped=true&lang=scss&"
import style1 from "./BannerPromo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1e516",
  null
  
)

component.options.__file = "BannerPromo.vue"
export default component.exports